import { CloseCircleFilled, ExclamationCircleFilled } from '@ant-design/icons'
import API from '@api/bi_nuo'
import Table from '@common/Table'
import { getMerchantInfo } from '@util'
import { Button, message, Modal } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import store from '../../../store'
import columns from './column'
import style from './index.module.less'
import { isWeddingRingJewelryProperty } from '@merchant-backend/util'
@observer
export default class extends Component {
  state = {
    selectedRowKeys: []
  }

  get key() {
    return this.props.tabKey
  }

  /** 选择案例 */
  onSelectChange = selectedRowKeys => {
    this.setState({
      selectedRowKeys
    })
  }

  /**
   * 批量上架/下架
   */
  multiSetPackage = () => {
    const { selectedRowKeys } = this.state
    if (!selectedRowKeys.length) {
      message.warn('请先选择案例')
      return
    }
    const operateType = this.key == 1 ? '下架' : '上架'
    Modal.confirm({
      title: `确定要批量${operateType}吗`,
      icon: <ExclamationCircleFilled style={{ color: '#ffbf00' }} />,
      onOk: async () => {
        // 过滤未整改数据
        const noCorrect = store.$list
          .filter(e => selectedRowKeys.includes(e.id))
          .map(e => e.normative)
          .filter(e => e != 1)
        const isSetArea = store.$list
          .filter(e => selectedRowKeys.includes(e.id))
          .findIndex(f => f.is_set_area === 0) // 查找是否存在未设置分区的数据

        if (noCorrect.length > 0 && this.key != 1) {
          Modal.error({
            title: `由于案例运营规则的调整，有${
              noCorrect.length
            }个案例信息缺失，请修改后发布案例，审核通过后即可上架。`,
            // content: '由于案例运营规则的调整，有3个案例信息缺失，请修改后发布案例，审核通过后即可上架。',
            okText: '知道了',
            icon: <CloseCircleFilled style={{ color: '#f5222d' }} />
          })
          return
        }

        // 当找到选中项中有未设置图片分区的 且 操作批量上架时
        if (isSetArea > -1 && this.key != 1) {
          Modal.error({
            title:
              '上架案例中存在未设置图片分区数据，请及时设置案例图片的区域即可上架。',
            okText: '知道了',
            icon: <CloseCircleFilled style={{ color: '#f5222d' }} />
          })
          return
        }

        const { RetCode, msg } = await API.multiSetPackageOrCaseApi({
          ids: selectedRowKeys,
          sold_out: this.key == 1 ? '1' : '0',
          commodity_type: '1' // 0套餐  1案例
        })

        if (RetCode === 0) {
          message.success('操作成功')
          this.onMultiOperateDone(true)
        } else if (RetCode === 1002) {
          Modal.warning({
            title: `操作成功`,
            content: msg,
            icon: <ExclamationCircleFilled style={{ color: '#ffbf00' }} />
          })
          this.onMultiOperateDone(false)
        } else {
          Modal.error({
            title: `操作失败`,
            content: msg,
            icon: <CloseCircleFilled style={{ color: '#f5222d' }} />
          })
        }
      }
    })
  }

  /**
   * 批量删除
   */
  multiDeletePackage = () => {
    const { selectedRowKeys } = this.state
    if (!selectedRowKeys.length) {
      message.warn('请先选择案例')
      return
    }
    Modal.confirm({
      title: `确定要批量删除吗`,
      content: (
        <div>
          <span style={{ color: '#F04134' }}>删除后内容不可恢复</span>，确定删除吗？
        </div>
      ),
      icon: <ExclamationCircleFilled style={{ color: '#ffbf00' }} />,
      onOk: async () => {
        const { RetCode, msg } = await API.multiDeletePackageOrCaseApi({
          ids: selectedRowKeys,
          commodity_type: '1' // 0套餐  1案例
        })

        if (RetCode === 0) {
          message.success('操作成功')
          this.onMultiOperateDone(true)
        } else if (RetCode === 1002) {
          Modal.warning({
            title: `操作成功`,
            content: msg,
            icon: <ExclamationCircleFilled style={{ color: '#ffbf00' }} />
          })
          this.onMultiOperateDone(false)
        } else {
          Modal.error({
            title: `操作失败`,
            content: msg,
            icon: <CloseCircleFilled style={{ color: '#f5222d' }} />
          })
        }
      }
    })
  }

  /** 批量操作结束，清空状态 */
  onMultiOperateDone = success => {
    const { $pagination, $getList, $list } = store
    const { current } = $pagination
    let page = current
    if (
      page > 1 &&
      success &&
      $list.length === this.state.selectedRowKeys.length
    ) {
      page = current - 1
    }
    this.setState({
      selectedRowKeys: []
    })
    $getList(page)
  }

  render() {
    const { key } = this
    const { multiSetPackage, multiDeletePackage, onSelectChange } = this
    const { selectedRowKeys } = this.state
    const { is_super } = getMerchantInfo() // 是否运营登录
    return (
      <div>
        <div className={style.operators}>
          {key == 1 &&
            !isWeddingRingJewelryProperty() && (
              <Button onClick={multiSetPackage} style={{ marginRight: 10 }}>
                批量下架
              </Button>
            )}
          {key == 4 &&
            !isWeddingRingJewelryProperty() && (
              <Button onClick={multiSetPackage} style={{ marginRight: 10 }}>
                批量上架
              </Button>
            )}
          {is_super && <Button onClick={multiDeletePackage}>批量删除</Button>}
        </div>
        <Table
          store={store}
          columns={columns()}
          rowSelection={{
            selectedRowKeys,
            onChange: onSelectChange
          }}
        />
      </div>
    )
  }
}
